import { useMemo, useState, useEffect } from 'react'

const usePresentationNavigation = (presentation, config = {}) => {
  const [activeSlideId, setActiveSlideId] = useState(null)

  useEffect(() => {
    if (presentation) {
      setActiveSlideId(config.activeSlideId || presentation.slides[0].id)
    }
  }, [presentation])

  const slides = presentation
    ? presentation.slides.filter(slide => !slide.hidden) || []
    : []

  const activeSlideIndex = useMemo(() => {
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].id === activeSlideId) {
        return i
      }
    }
    return 0
  }, [slides, activeSlideId])

  const isFirstSlide = activeSlideIndex === 0
  const isLastSlide =
    slides.length === 0 || activeSlideIndex === slides.length - 1

  const nextSlideId = !slides.length
    ? 0
    : isLastSlide
    ? !config.loop
      ? activeSlideId
      : slides[0].id
    : slides[activeSlideIndex + 1].id

  const prevSlideId = !slides.length
    ? 0
    : isFirstSlide
    ? !config.loop
      ? activeSlideId
      : slides[slides.length - 1].id
    : slides[activeSlideIndex - 1].id

  const slidePosition = `${activeSlideIndex + 1} / ${slides.length}`

  const nextSlide = () => setActiveSlideId(nextSlideId)
  const prevSlide = () => setActiveSlideId(prevSlideId)

  return {
    activeSlideIndex,
    isFirstSlide,
    isLastSlide,
    nextSlideId,
    prevSlideId,
    slidePosition,
    nextSlide,
    prevSlide,
    activeSlideId,
    setActiveSlideId
  }
}

export { usePresentationNavigation }
